import React from "react";
import { Actif } from "../../interfaces";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import IndicatorActifs from "./IndicatorActifs";
import { Tooltip } from "react-tooltip";
import { useAuth } from "../../utils/UserProvider";

interface ActionActifsProps {
  loading: boolean;
  actifs: Actif[];
  isGexpertise: () => boolean;
  isMaitreAdmin: () => boolean;
  isNotViewer: () => boolean;
  isAdminClient: () => boolean;
  openModal: (modalType: string) => void;
  setStatus: (status: string) => void;
  status: string;
  checked: boolean;
  setChecked: (checked: boolean) => void;
  filterBar: boolean;
  setFilterBar: (filerBar: boolean) => void;
  setSelectedStatus: (status: string) => void;
  setSelectedInterlocuteur: any;
  setSelectedIndividuIds: (individuIds: number[]) => void;
  setSelectedSocieteIds: (societeIds: number[]) => void;
  portefeuilles: any;
  selectedPortefeuille: any;
  setSelectedPortefeuille: any;
  setSearchQuery: (value: string) => void;
  searchQuery: string;
}

const ActionActifs = ({
  loading,
  actifs,
  isGexpertise,
  openModal,
  isMaitreAdmin,
  isNotViewer,
  isAdminClient,
  setStatus,
  checked,
  setChecked,
  filterBar,
  setFilterBar,
  setSelectedStatus,
  setSelectedInterlocuteur,
  setSelectedIndividuIds,
  setSelectedSocieteIds,
  selectedPortefeuille,
  portefeuilles,
  setSelectedPortefeuille,
  setSearchQuery,
  searchQuery,
  status,
}: ActionActifsProps) => {
  const { user, client } = useAuth();

  const visiblePortefeuilles = Array.isArray(portefeuilles)
  ? portefeuilles.filter(p =>
      p.proprietaire?.id === user.id ||
      p.users?.some(u => u.id === user.id)
    )
  : [];

  const selectedPortefeuilleTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.uuid}
            src="/images/portefeuille.png"
            className="mr-2"
            style={{ width: "18px" }}
          />
          <div>{option.nom_portefeuille}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const portefeuilleOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <img
          alt={option.uuid}
          src="/images/portefeuille.png"
          className="mr-2"
          style={{ width: "18px" }}
        />
        <div>{option.nom_portefeuille}</div>
      </div>
    );
  };

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  return (
    <>
      <div className="sm:flex sm:items-center sm:justify-between">
        <IndicatorActifs loading={loading} actifs={actifs} />
        <div className="flex items-center mt-4 gap-x-3">
          {( isAdminClient() || isMaitreAdmin()) && (
            <button
              data-tooltip-id="creer portefeuille"
              onClick={() => openModal("portefeuille")}
              className=" flex justify-center  px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
            >
              <img
                src="images/plus.png"
                className="inline-block h-3 mr-3 mt-1"
                alt="plus"
              />
              Portefeuille
            </button>
          )}
          {(isNotViewer() && !isGexpertise()) && (
            <button
              id="ActifTuto"
              data-tooltip-id="creer actif"
              onClick={() => openModal("actif")}
              className="flex justify-center w-1/2 px-5 py-2 text-md tracking-wide text-white transition-colors duration-200 bg-gexpertise-100 rounded-lg shrink-0 sm:w-auto gap-x-2 hover:bg-gexpertise-200 "
              
            >
              <img
                src="images/plus.png"
                className="inline-block h-3 mr-3 mt-1 flex-none"
                alt="plus"
              />
              Créer actif
            </button>
           
          )}
           <Tooltip id="creer actif" place="top" className="!z-50">
            Créer un actif
          </Tooltip>
          <Tooltip id="creer portefeuille" place="top" className="!z-50">
             Créer votre portefeuille
          </Tooltip>
         
        </div>
      </div>

      <div className="mt-6 md:flex md:items-center md:justify-between">
        <div
          role="group"
          className="inline-flex overflow-hidden bg-white border divide-x rounded-lg  rtl:flex-row-reverse "
        >
          <div>
            <button
              onClick={() => setStatus("layout_liste")}
              type="button"
              className={`px-5 py-2 text-md font-medium ${
                status == "layout_liste"
                  ? "text-white bg-gexpertise-200"
                  : "text-gexpertise-200 bg-transparent border border-gexpertise-200"
              }  rounded-l-lg hover:bg-gexpertise-200 hover:text-white`}
            >
              Liste
            </button>
            <button
              onClick={() => setStatus("layout_vignettes")}
              type="button"
              className={`px-4 py-2 text-md font-medium ${
                status == "layout_vignettes"
                  ? "text-white bg-gexpertise-200"
                  : "text-gexpertise-200 bg-transparent border border-gexpertise-200"
              }  rounded-r-lg hover:bg-gexpertise-200 hover:text-white`}
            >
              Vignettes
            </button>
          </div>
        </div>
        <div className="flex space-x-2">
          <div className="relative w-full">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                aria-hidden="true"
                className="w-5 h-5 text-gray-500 "
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              className="block p-2 pl-10 text-md text-gray-900 border border-gray-300 rounded-lg w-80  focus:ring-gexpertise-200 focus:border-gexpertise-200 "
              placeholder="Recherche"
              value={searchQuery}
              onChange={handleSearchChange}
            ></input>
          </div>
          <button
            onClick={() => {
              setFilterBar(!filterBar);
              setSelectedStatus("");
              setSelectedInterlocuteur(null);
              setSelectedIndividuIds([]);
              setSelectedSocieteIds([]);
            }}
            className="flex items-center justify-center  px-5 py-2 text-md text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto  hover:bg-gray-100 "
          >
            <img src="/images/sort.png" />
            Filtres
          </button>
        </div>
      </div>
      <div className="flex space-x-2 justify-between mt-2">
        <div className="flex items-center space-x-2 mt-4 ">
          <span className="text-lg  font-medium text-gray-900 ">
            Actifs non archivés
          </span>

          <InputSwitch
            checked={checked}
            onChange={(e) => setChecked(e.value)}
          />
        </div>
        {(isGexpertise() || isAdminClient() || isMaitreAdmin()) && (
          <div className="  flex space-x-2 justify-end mt-2">
            <Dropdown
              className="  text-md text-gray-900 border hover:border-gexpertise-200 border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-gexpertise-200 focus:border-gexpertise-200 "
              value={selectedPortefeuille}
              onChange={(e) => setSelectedPortefeuille(e.value)}
              options={visiblePortefeuilles}
              optionLabel="nom_portefeuille"
              placeholder="Choisir portefeuille..."
              filter
              showClear
              valueTemplate={selectedPortefeuilleTemplate}
              itemTemplate={portefeuilleOptionTemplate}
            />

            <form className="flex items-center">
              <label htmlFor="simple-search" className="sr-only">
                Search
              </label>

              <div className="relative w-full">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    className="w-5 h-5 text-gray-500 "
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <input
                  type="text"
                  id="simple-search"
                  className=" pointer-events-none blur-[2px] block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-gexpertise-200 focus:border-gexpertise-200 "
                  placeholder="Choisir client...."
                ></input>
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default ActionActifs;
